import HomeIcon from "@mui/icons-material/Home"
import { IconButton } from "@mui/material"
import React from "react"
import { useNamespacedTranslation } from "./hooks/useNamespacedTranslation"
import { useNavigate } from "react-router-dom"
import { StatButton, StatButtonSize } from "react-ui-components/components/StatButton"

export const HomeLink: React.FC<{
  iconOnly?: boolean
  size?: StatButtonSize
}> = ({ iconOnly, size = "md" }) => {
  const { t } = useNamespacedTranslation(['common'])
  const navigate = useNavigate()

  return (
    <>
      {iconOnly ? (
        <IconButton onClick={() => navigate("/#__t")}>
          <HomeIcon color="secondary" />
        </IconButton>
      ) : (
        <StatButton link icon={<HomeIcon />} label={t("Home")} onClick={() => navigate("/#__t")} />
        // <Link to="/#__t">
        //   <div className="flex items-center">
        //     <div className="flex flex-col items-center justify-center">
        //       <HomeIcon />
        //       <span className={clsx("text-white/95 font-semibold", sz.text)}>{t("Home")}</span>
        //       <ListItemText primary={t("Home")} />
        //     </div>
        //   </div>
        // </Link>
      )}
    </>
  )
}
